import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { GoalService } from '../commonServices/goal.service';

export const goalsResolver: ResolveFn<any> = (route, state) => {
  return inject(GoalService).get();
};
